// extracted by mini-css-extract-plugin
export default {"tableWrapper":"FAQs_tableWrapper__h98KC"};